import Link from 'next/link'
import { H1, P2, Font, useWindowSize } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import { ROUTES } from 'static/menusConstants'
import { getMonthDate } from 'modules/learn/learnUtils'
import { getCdnImg } from 'utils/getters'
import styles from './PrimaryArticle.module.scss'

const PrimaryArticle = ({ slug, type, logo, published, title, shortDescription }) => {
  const { screenWidth } = useWindowSize()
  return (
    <div className={styles.PrimaryArticle}>
      <Link
        href={type === 'article' ? `/${ROUTES.learnArticle}/${slug || ''}` : `/${ROUTES.learnArticleQA}/${slug || ''}`}
        prefetch={false}
      >
        <a className={styles.ArticleCard}>
          <div className={styles.Image}>
            {logo && (
              <img
                src={
                  getCdnImg(logo, screenWidth <= 401 ? 400 : 500) ||
                  'https://assets.moneymade.io/images/logos/Vector.svg'
                }
                alt="logo"
              />
            )}
          </div>

          <div className={styles.ArticleData}>
            {published && (
              <div className={styles.Meta}>
                <P2 as="span">{getMonthDate(published)}</P2>
              </div>
            )}

            {title && (
              <H1 type="heading" weight="bold" className={styles.Title}>
                {title}
              </H1>
            )}

            {shortDescription && (
              <Font
                as="p"
                font={{
                  default: { fontSize: '20px', lineHeight: '28px' },
                  sm: 'none'
                }}
              >
                {shortDescription}
              </Font>
            )}
          </div>
        </a>
      </Link>
    </div>
  )
}

PrimaryArticle.propTypes = {
  slug: PropTypes.string,
  type: PropTypes.string,
  logo: PropTypes.string,
  published: PropTypes.string,
  title: PropTypes.string,
  shortDescription: PropTypes.string
}

PrimaryArticle.defaultProps = {
  slug: '',
  type: '',
  logo: '',
  published: '',
  title: '',
  shortDescription: ''
}
export default PrimaryArticle
